import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import styles from './item.module.scss';
import {numberFormat} from "@/app/number";
import {useDispatch, useSelector} from "react-redux";
import {pause, play, setGlobalPlayerStatus} from "@/actions/player";
import {PLAYERSTATUS} from "@/constants";
import Like from "@/components/global/like";
import {PURCHASE} from "@/actions/types";

type Props = {
  key?: number,
  post: IPostItem
};

const PostItem: React.FC<Props> = ({ post }) => {
  const isPlayable = post.files.some(file => file.isPlayable);
  const postLink = `/post/${post.slug}`;
  const dispatch = useDispatch();

  const playingPost = useSelector((state: any) => state.player.post);
  const playerStatus = useSelector((state: any) => state.player.status);

  const globalPlay = () => {
    if(playerStatus === PLAYERSTATUS.PLAYING) {
      if(playingPost?.id === post.id)
        pause()(dispatch);
      else play(post)(dispatch);
    }
    else {
      if(playingPost?.id !== post.id)
        play(post)(dispatch);
      else setGlobalPlayerStatus(PLAYERSTATUS.PLAYING)(dispatch);
    }
  };

  const [playIcon, setPlayIcon] = useState('play');

  useEffect(() => {
    let plIcon = 'play';
    if(playingPost?.id === post.id) {
      if(playerStatus == PLAYERSTATUS.PLAYING) plIcon = 'pause';
      if(playerStatus == PLAYERSTATUS.REPEAT) plIcon = 'repeat';
      if(playerStatus == PLAYERSTATUS.LOADING) plIcon = 'spinner fa-spin';
    }
    return setPlayIcon(plIcon);
  }, [playingPost, playerStatus]);

  const buyPost = () => {
    dispatch({
      type: PURCHASE,
      payload: { postId: post.id }
    });
  }

  return (
    <div className={styles.postItem}>
      <div className={styles.imageContainer}>
        <svg width="400" height="400">
          <rect width="400" height="400" style={{fill: "rgb(0,0,0)"}} />
        </svg>
        <div className={styles.likeContainer}>
          <Like post={post} />
        </div>
        {isPlayable ? (
          <span className={styles.playIcon} onClick={globalPlay}>
            <i className={"fa fa-" + playIcon} />
          </span>
        ) : ''}
        <div className={styles.image}>
          <img src={post.image} alt={post.title} />
        </div>
        <div className={styles.detailsLink}>
          <Link to={postLink}>
            <span className={styles.title}>جزئیات آگهی <i className="fa fa-chevron-left" /></span>
          </Link>
        </div>
      </div>
      <div className={styles.info}>
        <h4 className={styles.title}><Link to={postLink}>{post.title}</Link></h4>
        <div className={styles.categories}>
          <div className={styles.iconContainer}>
            <i className="fa fa-tag" />
          </div>
          {post.subcategories.map((category, index) => (
              <React.Fragment key={category.slug + index + Math.random()}>
                {index < 3 ? (
                    <div className={styles.category}>
                      <Link to={`/posts/${category.slug}`}>
                        <span>{category.category}</span>
                      </Link>
                    </div>
                ) : ''}
              </React.Fragment>
          ))}
        </div>
        <Link to={`/artist/${post.artist.id}`} className={styles.artist}>
          <div className={styles.avatar}>
            <img src={post.artist.avatar} alt={post.artist.name} />
          </div>
          <span>{post.artist.name}</span>
          {post.artist.hasBadge ? <i className="fas fa-badge-check" /> : ''}
        </Link>
        {post.bought ? (
          <button className={styles.addedToBasket + ' btn btn-danger w-100'}>
            <i className="fa fa-ban" />{' '}
            <span>فروش رفته</span>
          </button>
        ) : (
            <>
            {post.price > 0 ? (
                <button className={styles.addToBasket + ' w-100 btn btn-primary'} onClick={buyPost}>
                    <i className="fa fa-shopping-cart" />{' '}
                    <span>
                    {post.real_price > post.price ? (
                        <>
                        <span className={styles.hasOff}>
                            <span className={styles.realPrice}>{numberFormat(post.real_price)}</span>
                            <span className={styles.offPrice}>{numberFormat(post.price)}</span>
                        </span>
                        <span> تومان </span>
                        </>
                    ) : numberFormat(post.price) + ' تومان'}</span>
                </button>
            ) : (
                <button className={styles.addToBasket + ' w-100 btn btn-success'}>
                  <i className="fa fa-gift" />{' '}
                  <span>رایگان</span>
                </button>
            )}
            </>
        )}
      </div>
    </div>
  );
}

export default PostItem;
